// All inline SVG icons used throughout the app, using currentColor
import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const IconDatabase = (props: IconProps): React.JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <ellipse cx='12' cy='5' rx='9' ry='3' />
    <path d='M3 5V19A9 3 0 0 0 21 19V5' />
    <path d='M3 12A9 3 0 0 0 21 12' />
  </svg>
);

export const IconDownload = (props: IconProps): React.JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <polyline points='7 10 12 15 17 10' />
    <line x1='12' x2='12' y1='15' y2='3' />
  </svg>
);

export const IconSearch = (props: IconProps): React.JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <circle cx='11' cy='11' r='8' />
    <path d='m21 21-4.3-4.3' />
  </svg>
);

export const IconTable = (props: IconProps): React.JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M12 3v18' />
    <rect width='18' height='18' x='3' y='3' rx='2' />
    <path d='M3 9h18' />
    <path d='M3 15h18' />
  </svg>
);

export const IconFileText = (props: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z' />
    <path d='M14 2v5h5' />
    <path d='M8 13h8' />
    <path d='M8 17h5' />
  </svg>
);
